"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Share["default"];
  }
});
var _Share = _interopRequireDefault(require("./Share"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }